import {HttpContextToken, HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from "@angular/common/http";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {OidcSecurityService} from "angular-auth-oidc-client";

export const IGNORE_401_ERROR = new HttpContextToken<boolean>(() => false);

/**
 * Guards against a redirect storm. A burst of 401s (e.g. the dashboard firing
 * several /api calls at once, or a token expiring mid-flight) would otherwise
 * call authorize() once per failed request, each redirect aborting the previous
 * one. We only ever kick off a single re-authentication.
 */
let reauthInFlight = false;
// Safety valve: if authorize() does not actually navigate away (misconfig,
// blocked redirect), clear the guard so a later 401 can retry instead of
// wedging the app into a state where it never re-authenticates.
const REAUTH_GUARD_RESET_MS = 15_000;

export function http401Interceptor(req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const router = inject(Router);
  const oidcSecurityService = inject(OidcSecurityService);

  if (req.context.get(IGNORE_401_ERROR)) {
    return next(req)
  }
  return next(req).pipe(tap(event => {
  }, err => {
    handleError(err, oidcSecurityService);
  }));
}

function handleError(err: HttpErrorResponse, oidcSecurityService: OidcSecurityService) {
  if (err.status !== 401) {
    return;
  }
  if (reauthInFlight) {
    return;
  }
  reauthInFlight = true;
  setTimeout(() => (reauthInFlight = false), REAUTH_GUARD_RESET_MS);
  oidcSecurityService.authorize();
}
